export class CreateBookingV3Mapper {}
